import React, { PropTypes, Component } from 'react';
import { v4 } from 'node-uuid';
import Money from 'common/components/money';
import AssureAwardsModal from 'project/containers/assure_awards_modal';
import { CheckBoxField } from 'common/components/form_fields';

export default class Awards extends Component {
  render() {
    const { awards, canEdit, toggleModal, toggleAssureModal, project } = this.props;
    const total = awards.reduce((mem, { value }) => (mem + (value * 1)), 0);

    return (<div className="sidebar-container">
      <h3>Awards</h3>

      <table className="table table-awards">
        <tbody>
          {awards.map(({ value }, key) => (
            <tr key={v4()}>
              <td>Award {key + 1}</td>
              <td className="amount"><Money value={value} showDecimals={true} /></td>
            </tr>
          ))}
          <tr className="total">
            <td>Total</td>
            <td className="amount"><Money value={total} showDecimals={true} /></td>
          </tr>
        </tbody>
      </table>

      { canEdit && <button type="button" onClick={toggleModal} className="btn btn-secondary btn-md">
        { project.is_one_to_one? 'Increase Award' : 'Change Awards' }
      </button> }

      <div className="assured-container">
        {project.assured && !project.elite_only &&
        <div className="assured text-success">
          <i className="fa fa-check-circle"/> Your awards are assured
        </div>}

        {!project.assured && !project.elite_only && canEdit &&
        <CheckBoxField meta={{}} label="Assure your awards"
          input={{
            value: project.assured,
            name: 'assure_awards',
            onChange: toggleAssureModal
          }}
          description="Assuring someone will win the award shows creatives that you're
                       a committed client."/>}
      </div>

      <AssureAwardsModal />

    </div>);
  }
}

Awards.propTypes = {
  awards: PropTypes.array.isRequired,
  toggleModal: PropTypes.func.isRequired,
  toggleAssureModal: PropTypes.func.isRequired,
  canEdit: PropTypes.bool.isRequired,
  project: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./project/components/awards.jsx